import {createSlice, type SliceSelectors} from '@reduxjs/toolkit'

import {getTradeAccountInfoByDetail} from '@web/actions/detail'
import {OrderPaymentDetailState, getInitialState} from '@web/slices/orderPaymentDetail/slice'

import {OrderPaymentDetailReducers, MakeSliceOptions} from './interfaces'

export default (options?: MakeSliceOptions) =>
    createSlice<
        OrderPaymentDetailState,
        OrderPaymentDetailReducers,
        'orderPaymentDetail',
        SliceSelectors<OrderPaymentDetailState>
    >({
        name: 'orderPaymentDetail',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder.addCase(getTradeAccountInfoByDetail.fulfilled, (state, {payload}) => {
                if (state.trade) {
                    state.trade.data = {
                        naverFinancial: {
                            bankName: payload.naverFinancialBankName,
                            maskedAccountNo: payload.naverFinancialMaskedAccountNo,
                        },
                        purchaser: {
                            bankName: payload.purchaserBankName,
                            maskedAccountNo: payload.purchaserMaskedAccountNo,
                        },
                    }
                }
            })
            options?.extraReducers?.(builder)
            // builder.addMatcher
        },
    })
